import Moment from "moment";
import dayjs from "dayjs";
import { getToken, getUser } from "../commons";
import { getAPICall, postAPICall } from "./axiosCommons";
import axios from "axios";
import { toast } from "react-toastify";

axios.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    // Handle 401 error (unauthorized)
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      toast.error("Session expired. Logging out now...")
      setTimeout(() => {
        window.location.href = "/" // Redirect to the login page after 1 second
      }, 1000)
    }
    return Promise.reject(error)
  },
)

export const searchFormResponses = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "forms/search",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(data.dateFrom).format("YYYY-MM-DD"),
        date_to: Moment(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportFormResponses = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? Moment(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? Moment(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const response = await getAPICall(
      process.env.REACT_APP_LINK + "forms/export",
      {
        requester,
        token,
        date_from,
        date_to,
        encoded_by
      },
      { responseType: 'blob' }
    );

    // Create blob and download
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `form_responses_${date_from}_to_${date_to}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const formCIP = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "CipRollouts/get",
      {
        requester: getUser(),
        token: getToken(),
        date_from: dayjs(data.dateFrom).format("YYYY-MM-DD"),
        date_to: dayjs(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportCipRollout = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? dayjs(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? dayjs(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const url = 
      process.env.REACT_APP_LINK +
      `CipRollouts/export?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&encoded_by=${encoded_by}`;

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Cip_${date_from}_to_${date_to}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    return { error: error.response };
  }
};

export const formIncentive = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "IncentiveVerifications/get",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(data.dateFrom).format("YYYY-MM-DD"),
        date_to: Moment(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportIncentiveVerification = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? Moment(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? Moment(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const url = 
      process.env.REACT_APP_LINK +
      `IncentiveVerifications/export?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&encoded_by=${encoded_by}`;

    // Open a blank temporary tab
    const newTab = window.open("", "_blank");

    // Inject a script inside the new tab to download the file and close afterwards
    newTab.document.write(`
      <html>
        <body>
          <script>
            window.location.href = "${url}";
            setTimeout(() => window.close(), 2000);
          <\/script>
        </body>
      </html>
    `);
  } catch (error) {
    return { error: error.response };
  }
};

export const formFlagship = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "FlagshipStores/get",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(data.dateFrom).format("YYYY-MM-DD"),
        date_to: Moment(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportFlagshipStore = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? Moment(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? Moment(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const url = 
      process.env.REACT_APP_LINK +
      `FlagshipStores/export?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&encoded_by=${encoded_by}`;

    // Open a blank temporary tab
    const newTab = window.open("", "_blank");

    // Inject a script inside the new tab to download the file and close afterwards
    newTab.document.write(`
      <html>
        <body>
          <script>
            window.location.href = "${url}";
            setTimeout(() => window.close(), 2000);
          <\/script>
        </body>
      </html>
    `);
  } catch (error) {
    return { error: error.response };
  }
};

export const formMerienda = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "Meriendas/get",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(data.dateFrom).format("YYYY-MM-DD"),
        date_to: Moment(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportMerienda = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? Moment(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? Moment(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const url = 
      process.env.REACT_APP_LINK +
      `Meriendas/export?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&encoded_by=${encoded_by}`;

    // Open a blank temporary tab
    const newTab = window.open("", "_blank");

    // Inject a script inside the new tab to download the file and close afterwards
    newTab.document.write(`
      <html>
        <body>
          <script>
            window.location.href = "${url}";
            setTimeout(() => window.close(), 2000);
          <\/script>
        </body>
      </html>
    `);
  } catch (error) {
    return { error: error.response };
  }
};

export const formMayaCredits = async (data, page) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "MayaCredits/get",
      {
        requester: getUser(),
        token: getToken(),
        date_from: Moment(data.dateFrom).format("YYYY-MM-DD"),
        date_to: Moment(data.dateTo).format("YYYY-MM-DD"),
        encoded_by: data.agent,
        page: page,
      }
    );
    //// console.log(response.data);
    return { data: response.data };
  } catch (error) {
    //// console.log(error.response);
    return { error: error.response };
  }
};

export const exportMayaCredits = async (data) => {
  try {
    const requester = getUser();
    const token = getToken();
    const date_from = data.dateFrom ? Moment(data.dateFrom).format("YYYY-MM-DD") : '';
    const date_to = data.dateTo ? Moment(data.dateTo).format("YYYY-MM-DD") : '';
    const encoded_by = data.agent || '';

    const url = 
      process.env.REACT_APP_LINK +
      `MayaCredits/export?requester=${requester}&token=${token}&date_from=${date_from}&date_to=${date_to}&encoded_by=${encoded_by}`;

    // Open a blank temporary tab
    const newTab = window.open("", "_blank");

    // Inject a script inside the new tab to download the file and close afterwards
    newTab.document.write(`
      <html>
        <body>
          <script>
            window.location.href = "${url}";
            setTimeout(() => window.close(), 2000);
          <\/script>
        </body>
      </html>
    `);
  } catch (error) {
    return { error: error.response };
  }
};
